export default __webpack_public_path__ + "static/media/green_circle.34cf3d2a.svg";